import React from "react";

import "../styles/bulma_loader.scss";
import "../styles/main.scss";

import Layout from "../components/Layout";

const IndexPage = () => {
  return (
    <Layout>
      <div className="card full-width block has-text-centered">
        <div className="card-content">
          <h1 className="title is-size-1" id="title">
            {" "}
            Achtung{" "}
          </h1>
          <div className="content is-size-4">
            <p>
              Im Zeitraum bis einschließlich 24. Mai sind Termine <strong>aussschließlich Teilnehmern an der Bezirksmeisterschaft vorbehalten.</strong>
            </p>
            <p>
              <form
                style={{ display: "inline" }}
                action="https://booking.sgi-flieden.de"
                method="get"
              >
                <button className="button is-link is-large is-fullwidth mb-4">
                  <span>Zu den Buchungen</span>
                </button>
              </form>
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default IndexPage;
